import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/zero-box-1.png'
import _imports_1 from '../images/zero-box-2.png'


const _withScopeId = n => (_pushScopeId("data-v-bb9daad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zero-wrapper relative d-none d-sm-block" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-6 d-flex relative" }
const _hoisted_4 = {
  key: 0,
  class: "box-1 mx-auto",
  src: _imports_0
}
const _hoisted_5 = {
  key: 1,
  class: "box-1 mx-auto",
  src: _imports_1,
  style: {"object-fit":"contain"}
}
const _hoisted_6 = { class: "col-6 ps-5" }
const _hoisted_7 = { class: "h-100 d-flex flex-column" }
const _hoisted_8 = { class: "font-Pretendar cola-color mt-auto" }
const _hoisted_9 = {
  key: 0,
  class: "text-44 mt-md-300"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" GS25 ‘반값택배' 서비스 이용이 가능한 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 사이즈에요! 캠퍼스 내 다양한 장소에서 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 모은 투명 음료 페트병을 박스에 가득 모아 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 가까운 GS25편의점에 방문해주세요. ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 500ml PET 기준 약 45개~50개를 담을 수 있어요 ")
const _hoisted_19 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-44 text-18 lh-sm" }, [
  /*#__PURE__*/_createTextVNode(" 페트병을 모을 제로 웨이스트 박스는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "75L"),
  /*#__PURE__*/_createTextVNode(" 종량제 쓰레기 봉투와 비슷한 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 크기에요. ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-27" }, [
  /*#__PURE__*/_createTextVNode(" 모두의 챌린지 참여자로 선정되신 분들에게는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
    /*#__PURE__*/_createTextVNode("2개의 제로 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 웨이스트 박스")
  ]),
  /*#__PURE__*/_createTextVNode("가 발송됩니다. ")
], -1))
const _hoisted_22 = { class: "container zero-wrapper d-block d-sm-none" }
const _hoisted_23 = { class: "h-100 d-flex flex-column" }
const _hoisted_24 = {
  key: 0,
  class: "box-1 mx-auto",
  src: _imports_0
}
const _hoisted_25 = {
  key: 1,
  class: "box-1 mx-auto mt-5 pt-3",
  src: _imports_1
}
const _hoisted_26 = { class: "font-Pretendar cola-color mt-auto" }
const _hoisted_27 = {
  key: 0,
  class: "text-18"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" GS25 ‘반값택배' 서비스 이용이 가능한 ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 사이즈에요! 캠퍼스 내 다양한 장소에서 ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 모은 투명 음료 페트병을 박스에 가득 모아 ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 가까운 GS25편의점에 방문해주세요. ")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 500ml PET 기준 약 45개~50개를 담을 수 있어요 ")
const _hoisted_37 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-18" }, [
  /*#__PURE__*/_createTextVNode(" 페트병을 모을 제로 웨이스트 박스는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "75L"),
  /*#__PURE__*/_createTextVNode(" 종량제 쓰레기 봉투와 비슷한 크기예요. ")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-14 mt-2" }, [
  /*#__PURE__*/_createTextVNode(" 모두의 챌린지 참여자로 선정되신 분들에게는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "2개의 제로 웨이스트 박스"),
  /*#__PURE__*/_createTextVNode("가 발송됩니다. ")
], -1))

import HeadingBox from '@/templates/campaign-cocacola-season-6/components/heading-box.vue';

interface Props {
  type: 'campus' | 'everyone';
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.type === 'everyone')
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(HeadingBox, {
              title: 'Zero Waste Box',
              type: 'challenge'
            }),
            _createElementVNode("div", _hoisted_8, [
              (__props.type === 'campus')
                ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _hoisted_19))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_20,
                    _hoisted_21
                  ], 64))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(HeadingBox, {
          title: 'Zero Waste Box',
          type: 'challenge'
        }),
        (__props.type === 'everyone')
          ? (_openBlock(), _createElementBlock("img", _hoisted_24))
          : (_openBlock(), _createElementBlock("img", _hoisted_25)),
        _createElementVNode("div", _hoisted_26, [
          (__props.type === 'campus')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_27, _hoisted_37))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_38,
                _hoisted_39
              ], 64))
        ])
      ])
    ])
  ], 64))
}
}

})